"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactHotLoader = require("react-hot-loader");

var _reactRedux = require("react-redux");

var _reduxModal = require("redux-modal");

var _selections = require("../../../redux/modules/_BETA/selections");

var _InsightEquips = _interopRequireDefault(require("./InsightEquips"));

var _requestSchedule = require("../../../redux/modules/_BETA/requestSchedule");

const mapStateToProps = state => ({
  appSetupComplete: state.appSetup.appSetupComplete,
  userSites: state.userSites,
  userDisplayName: state.auth.user.display_name,
  shouldRequest: state.requestSchedule.shouldRequestInsights,
  error: state.insights.error,
  selectedSites: state.betaSelections.selectedSites,
  showSnoozed: state.insights.showSnoozed,
  urlHistory: state.urlHistory,
  timeRange: state.betaSelections.daysRange
});

const mapDispatchToProps = dispatch => ({
  showModal: (equipRuleIds, hits, createNewIssue = false) => {
    // Also include equipNames by searching through all hits to find ones that
    // match the supplied ids
    const equipNames = equipRuleIds.map(id => {
      const hit = hits.find(h => h.equipRuleId === id);
      return hit ? hit.targetName : null;
    }).filter(h => h !== null);
    return () => dispatch((0, _reduxModal.show)('TRIAGE_ACTION_MODAL', {
      equipRuleIds,
      equipNames,
      createNewIssue
    }));
  },
  setMultiSite: syncoId => {
    dispatch((0, _selections.updateIsMultiSiteRoute)(false));
    dispatch((0, _selections.selectActiveSite)(syncoId));
  },
  setShouldRequest: shouldRequestInsights => {
    dispatch((0, _requestSchedule.setShouldRequestInsights)(shouldRequestInsights));
  }
});

const EquipScene = props => {
  if (!props.appSetupComplete) return null;
  return /*#__PURE__*/React.createElement(_InsightEquips.default, props);
};

var _default = (0, _reactHotLoader.hot)(module)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EquipScene));

exports.default = _default;
module.exports = exports.default;